// @ts-check
import { BehaviorSubject, Observable, from, combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

var getHeaders = {
  'Accept': 'application/json'
};

var postHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};





/** @type {import('types/api').V1.SubscriptionPlan} */
const NO_PLAN = {
  plan_id: null,
  interval: 'time',
  amount: '--',
  trialPeriodDays: 0,
  name: 'Unknown',
  intervalCount: 1,
  metadata: {},
};

export class SubscriptionService {

  /** @type {Observable<import('types/api').V1.UserSubscription>} */
  subscription$;
  /** @type {Observable<import('types/api').V1.SubscriptionPlan>} */
  plan$;
  /** @type {boolean} */
  hasSubscription = false;

  fetchSubscriptionManagementStrategy() {
    return this._$q.resolve(this._SubscriptionResource.fetchManagementStrategy().$promise);
  }

  _SubscriptionResource;
  _PlanResource;
  /** @type {SubscriptionService.UserService} */
  _UserService;

  /** @type {ng.IQService} */
  _$q;

  /**
   * @param {any} SubscriptionResource
   * @param {any} PlanResource
   * @param {SubscriptionService.UserService} UserService
   * @param {ng.IQService} $q
   */
  constructor(
    SubscriptionResource,
    PlanResource,
    UserService,
    $q,
  ) {
    this._SubscriptionResource = SubscriptionResource;
    this._PlanResource = PlanResource;
    this._UserService = UserService;
    this._$q = $q;

    this.subscription$ = this._UserService.user$
      .pipe(
        map(_ => _.subscription),
        distinctUntilChanged()
      );

    this.subscription$.subscribe(_ => {
      this.hasSubscription = ['trialing', 'active', 'past_due'].includes(_?.status);
    });

    const defaultPlanSubject = new BehaviorSubject(NO_PLAN);

    this.plan$ = combineLatest(defaultPlanSubject, this.subscription$)
      .pipe(
        map(([defaultPlan, subscription]) => subscription?.plan ?? defaultPlan ?? NO_PLAN),
        distinctUntilChanged(),
      );

    this._PlanResource.fetchPlan({id: 'default'})
      .$promise
      .then(_ => defaultPlanSubject.next(_))
      .catch(err => console.error("Error fetching default plan: ", err))
      .then(_ => defaultPlanSubject.complete());

    this._UserService.user$
      .subscribe(user => {

      })
  }
}

export default [
  'SubscriptionResource',
  'PlanResource',
  'UserService',
  '$q',
  SubscriptionService,
]

/**
 * @typedef {import('./user.service').UserService} SubscriptionService.UserService
 */




  // export interface SubscriptionService {
  //   subscription: V1.UserSubscription | null;
  //   plan: V1.SubscriptionPlan | null;
  //   hasSubscription: boolean;

  //   fetchSubscriptionManagementStrategy(): IPromise<V2.FetchManagementSubscriptionStrategy.Response>;

  //   on(
  //     eventName: SubscriptionService.ChangeListener['eventName'],
  //     handler: SubscriptionService.ChangeListener['handler'],
  //   ): void;
  // }

  // export namespace SubscriptionService {
  //   export type Constructor = (
  //     this: SubscriptionService,
  //     Subscription: ISubscriptionResource,
  //     Plan: IPlanResource,
  //     UserService: UserService,
  //     $q: ng.IQService
  //   ) => void;

  //   export type Listener = ChangeListener;

  //   export type ChangeListener = {
  //     eventName: 'change';
  //     handler: (user: V1.UserSubscription) => void;
  //   };
  // }
